/* eslint-disable react/prop-types */
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";

const RHFTextField = ({ formData, control }) => {


    // Generate validation rules dynamically
    const rules = formData?.Validations?.reduce((acc, validation) => {
        if (validation.ValidationType === "Required") {
            acc.required = validation.ValidationMessage || "This field is required";
        } else if (validation.ValidationType === "Pattern" && validation.ValidationPattern) {
            acc.pattern = {
                value: new RegExp(validation.ValidationPattern),
                message: validation.ValidationMessage || "Invalid input",
            };
        } else if (validation.ValidationType === "Decimal") {
            acc.pattern = {
                value: /^[0-9]+(\.[0-9]+)?$/, // NOSONAR
                message: validation.ValidationMessage || "Please enter a valid decimal number",
            };
        }
        return acc;
    }, {});



    return (
        <Controller
            name={formData?.ValueExpr}
            control={control}
            rules={rules}
            render={({ field, fieldState: { error } }) =>
            (
                

                    <TextField
                        {...field}
                        size="small"
                        label={<>{formData?.LabelName || formData?.DisplayExpr}{rules?.required && (
                            <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                        )}</>}
                        variant="outlined"
                        // error={!!error}
                        value={field.value || ''}
                        helperText={
                            error && <span style={{ color: "red", fontSize: "10px" }}>{error.message}</span>
                        }
                        fullWidth
                        sx={{
                            "& .MuiInputBase-input": {
                                fontSize: "13px",
                            },
                            "& .MuiFormLabel-root": {
                                fontSize: "14px",
                            },
                        }}
                    />
            

            )
            }
        />
    );
};

export default RHFTextField;
